<template>
  <div class="map">
    <h2 class="map--title" v-if="title">{{ title }}</h2>
    <div class="map--container">
      <div class="map--popup-wrapper" ref="information">
        <transition name="map-popup" v-on:enter="popupEnter" v-on:leave="popupLeave">
          <div class="map--popup" v-if="popupState">
            <div class="map--popup-overlay"/>
            <div class="close" @click="clear()"><CloseIcon/></div>
            <div class="map--popup-inner">
              <h3 class="map--popup-title" v-html="activeItem.title"/>
              <div class="map--popup-content" v-html="activeItem.content"/>
              <div class="map--popup-carousel">
                  <agile  v-if="hasPopupImage(activeItem)" ref="carousel" :autoplay="true" :dots="false" :navButtons="false" :autoplaySpeed="3000" :speed="500">
                    <div v-for="(item,key) in activeItem.image" :key="key" class="slide">
                      <img :src="imageUrl(item)" :alt="item.title" />
                    </div>
                </agile>
              </div>
            </div>
          </div>
        </transition>
        <div class="map--popup-instruction" v-if="!popupState">
          <div class="instruction--pin"><Pin/></div>
          <div class="instruction">Click a pin to explore</div>
        </div>
      </div>
      <div class="map--wrapper">
        <div class="map-background-wrapper" @click="clear">
          <img src="@/assets/map/map.png"/>
        </div>
        <div class="map-items" ref="mapItems">
          <div class="map-pin" v-for="item in mapItems" :key="item.id" v-bind:style="pinPosition(item)" @click="popup(item)">
            <div class="map-pin-line" v-if="activeItem == item"/>
            <Pin/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import Pin from "../assets/svg/pin.svg"
import CloseIcon from "../assets/svg/close.svg"

import { developmentFixImageUrls } from '../helpers'

export default {
  name: "Map",
  components: {
    Pin,
    agile: VueAgile,
    CloseIcon
  },
  props: {
    mapItems: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: String,
      default: function() {
        return '';
      }
    }
  },
  data() {
    return {
      popupState: false,
      activeItem: {},
      errors: []
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {

    },
    pinPosition(item) {
      return {
        left: item.x ? item.x : 0,
        top: item.y ? item.y : 0,
      }
    },
    popup: function(item) { // eslint-disable-line no-unused-vars
      let activateItem = (item) => {
        this.popupState = true;
        this.activeItem = item;
        if (this.$refs.information) {
          this.$refs.information.scrollIntoView({behavior: 'smooth'})
        }
        setTimeout(()=>{
          let line = this.$refs.mapItems.querySelector('.map-pin-line');
          if (line) {
            line.style.width = '3000px';
          }
        }, 100)
      }
      if (this.popupState) {
        //Close and open
        this.popupState = false;
        setTimeout(() => {
          activateItem(item);
        },500)
      } else {
        activateItem(item)
      }      
    },
    clear() {
      this.popupState = false;
      this.activeItem = {};
    },
    popupEnter: function(el, done) {
      el.parentNode.classList.add('active');
      let image = el.querySelector('.map--popup-carousel');
      let c = this;
      setTimeout(() => {
        image && image.classList.add('image-active');
        //Forces carousel to reinitialize - like calling resize
        c.$refs.carousel.getWidth();
        done()
      }, 500);
      done();
    },
    popupLeave: function(el, done) {
      el.parentNode.classList.remove('active');
      setTimeout(() => {done()}, 1000);

    },
    hasPopupImage: function(item) {
      return item.image && item.image[0];

    },
    imageUrl(image) {
      //Only in development
      if (process.env.NODE_ENV == 'development') {
        return developmentFixImageUrls(image.imageUrl);
      }
      return image.imageUrl;
    }
  },
  ready: function() {
    window.addEventListener("resize", this.chartSize);
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.chartSize);
  }
};
</script>

<style>
.multiselect__tag {
  background-color: #30b5e4;
  color: #0b1f3e;
}
</style>

<style scoped lang="scss">
.map--container {
  position: relative;
  display: flex;
  overflow-x: scroll;
  background-color: $color-background-primary;
  .map--popup-wrapper {
    width: 33.3%;
    display: flex;
    transition: all 0.3s ease;
    &.active {

    }
  }
  .map--popup {
    position: relative;
    width: 100%;
    flex: 0 0 auto;
    background-color: $color-background-primary;
    overflow: hidden;
    .map--popup-carousel {
      opacity:0;
      transition: opacity 0.5s ease-in;
      &.image-active {
        opacity: 1;
      }
    }
  }
  .map--wrapper {
    position: relative;
    width: 66.6%;
    overflow: hidden;
  }
}
.map-pin {
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
}
.map--popup-overlay {
  top: -20px;
  left: -30px;
  position: absolute;
  height: 120%;
  width: 200%;
  background-color: #ffffff;
  transition: all 1s ease-in-out;
  transform: rotate(-3deg);
}
.map-popup-enter-to {
  .map--popup-overlay {
    top: -130%;
  }
}
.map-popup-leave-active {
  .map--popup-overlay {
    top: -20px;
  }
}
.map--popup-content {
  padding: 25px 25px 50px 25px;
  color: #ffffff;
  text-align: left;
}
.map--popup-title {
  padding: 25px 25px 0px 25px;
  color: #ffffff;
  text-align: left;
}
.map-pin-line {
  width: 0;
  height:2px;
  background-color: $color-background-primary;
  transition: width 1s ease;
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
}
.map--title {
  width: 100%;
  text-align: center;
  margin-bottom: $spacing-x2;
}

.map-background-wrapper {
  img {
    width: 100%;
  }
}

.close {
  position: absolute;
  width: 50px;
  height: 50px;
  right: 25px;
  top: 10px;
  cursor: pointer;
  svg {
    width: 100%;
    height: 100%;
    .icon {
      fill: $color-text-on-background-primary;
    }
  }
}
.map--popup-instruction {
  display: flex;
  width: 100%;
  margin-top: $spacing-x2;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;
  > div {
    width: 100%;
    color: $color-text-on-background-primary;
    text-align: center;
  }
  svg {
    border: 3px solid $color-text-on-background-primary;
    border-radius: 50%;
  }
}

@media (max-width: 768px) {
  .map--container {
    flex-wrap: wrap;
    .map--popup-wrapper, .map--wrapper {
      width: 100%;
    }
  }
  .map-pin {
    transform: translateX(-50%) translateY(-50%) scale(0.6);
  }
}

</style>